export default {
  en: {
    client: {
      openProfile: 'Profile',
      openLogin: 'Sign in',
      profileTitle: 'Profile',
      loginTitle: 'Sign in',
      registerTitle: 'Create account',
      email: 'Email',
      password: 'Password',
      firstName: 'First name',
      lastName: 'Last name',
      phone: 'Phone',
      loginSubmit: 'Sign in',
      registerSubmit: 'Register',
      goToRegister: 'Create an account',
      goToLogin: 'Already have an account? Sign in',
      changePassword: 'Change password',
      editProfileTitle: 'Edit profile',
      editProfileSave: 'Save',
      editProfileSuccess: 'Profile updated',
      profileNamePlaceholder: 'Name',
      profilePhonePlaceholder: 'Phone',
      logout: 'Sign out',
    },
    courier: {
      profileTitle: 'Profile',
      loginTitle: 'Sign in',
      registerTitle: 'Courier registration',
      email: 'Email',
      password: 'Password',
      firstName: 'First name',
      lastName: 'Last name',
      phone: 'Phone',
      loginSubmit: 'Sign in',
      registerSubmit: 'Register',
      goToRegister: 'Create a courier account',
      goToLogin: 'Already have an account? Sign in',
      logout: 'Sign out',
    },
    restaurant: {
      openProfile: 'Profile',
      openLogin: 'Sign in',
      profileTitle: 'Profile',
      loginTitle: 'Restaurant sign in',
      registerTitle: 'Restaurant registration',
      email: 'Email',
      password: 'Password',
      title: 'Restaurant title',
      loginSubmit: 'Sign in',
      registerSubmit: 'Register',
      goToRegister: 'Create a restaurant account',
      goToLogin: 'Already have an account? Sign in',
      logout: 'Sign out',
    },
    admin: {
      openProfile: 'Profile',
      openLogin: 'Sign in',
      profileTitle: 'Profile',
      loginTitle: 'Admin sign in',
      email: 'Email',
      password: 'Password',
      loginSubmit: 'Sign in',
      logout: 'Sign out',
    },
    validation: {
      emailRequired: 'Enter your email',
      emailInvalid: 'Invalid email address',
      passwordRequired: 'Enter your password',
      passwordMin: 'Password must be at least {min} characters',
      currentPasswordRequired: 'Enter your current password',
      confirmPasswordRequired: 'Confirm the new password',
      passwordsMustMatch: 'Passwords do not match',
      titleRequired: 'Enter restaurant title',
      phoneInvalid: 'Enter a valid phone number ({min}–{max} digits)',
    },
    changePassword: {
      title: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Repeat new password',
      save: 'Save',
      success: 'Password updated',
    },
    apiErrors: {
      generic: 'Something went wrong. Try again later.',
      routeNotFound: 'Service is unavailable. Check that the server is running and routes are configured.',
      server_error: 'Server error. Try again later.',
      unauthorized: 'Sign in required',
      auth_failed: 'Invalid email or password',
      validation_error: 'Check the entered data',
      ValidationError: 'Check the entered data',
      user_exists: 'This email is already registered',
      auth_wrong_password: 'Current password is incorrect',
      auth_same_password: 'New password must be different from the current one',
    },
    roleMismatchTitle: 'Wrong app',
    roleMismatchMessage:
      'This build is for {expected}. You are signed in as {actual}. Open the correct app or sign out.',
    roleMismatchLogout: 'Sign out',
  },
  ru: {
    client: {
      openProfile: 'Профиль',
      openLogin: 'Войти',
      profileTitle: 'Профиль',
      loginTitle: 'Вход',
      registerTitle: 'Регистрация',
      email: 'Email',
      password: 'Пароль',
      firstName: 'Имя',
      lastName: 'Фамилия',
      phone: 'Телефон',
      loginSubmit: 'Войти',
      registerSubmit: 'Зарегистрироваться',
      goToRegister: 'Создать аккаунт',
      goToLogin: 'Уже есть аккаунт? Войти',
      changePassword: 'Изменить пароль',
      editProfileTitle: 'Редактировать профиль',
      editProfileSave: 'Сохранить',
      editProfileSuccess: 'Профиль обновлён',
      profileNamePlaceholder: 'Имя',
      profilePhonePlaceholder: 'Телефон',
      logout: 'Выйти',
    },
    courier: {
      profileTitle: 'Профиль',
      loginTitle: 'Вход',
      registerTitle: 'Регистрация курьера',
      email: 'Email',
      password: 'Пароль',
      firstName: 'Имя',
      lastName: 'Фамилия',
      phone: 'Телефон',
      loginSubmit: 'Войти',
      registerSubmit: 'Зарегистрироваться',
      goToRegister: 'Создать аккаунт курьера',
      goToLogin: 'Уже есть аккаунт? Войти',
      logout: 'Выйти',
    },
    restaurant: {
      openProfile: 'Профиль',
      openLogin: 'Войти',
      profileTitle: 'Профиль',
      loginTitle: 'Вход для ресторана',
      registerTitle: 'Регистрация ресторана',
      email: 'Email',
      password: 'Пароль',
      title: 'Название ресторана',
      loginSubmit: 'Войти',
      registerSubmit: 'Зарегистрироваться',
      goToRegister: 'Создать аккаунт ресторана',
      goToLogin: 'Уже есть аккаунт? Войти',
      logout: 'Выйти',
    },
    admin: {
      openProfile: 'Профиль',
      openLogin: 'Войти',
      profileTitle: 'Профиль',
      loginTitle: 'Вход для админа',
      email: 'Email',
      password: 'Пароль',
      loginSubmit: 'Войти',
      logout: 'Выйти',
    },
    validation: {
      emailRequired: 'Укажите email',
      emailInvalid: 'Некорректный email',
      passwordRequired: 'Укажите пароль',
      passwordMin: 'Пароль не короче {min} символов',
      currentPasswordRequired: 'Укажите текущий пароль',
      confirmPasswordRequired: 'Повторите новый пароль',
      passwordsMustMatch: 'Пароли не совпадают',
      titleRequired: 'Укажите название ресторана',
      phoneInvalid: 'Укажите корректный телефон ({min}–{max} цифр)',
    },
    changePassword: {
      title: 'Сменить пароль',
      currentPassword: 'Текущий пароль',
      newPassword: 'Новый пароль',
      confirmPassword: 'Повтор нового пароля',
      save: 'Сохранить',
      success: 'Пароль обновлён',
    },
    apiErrors: {
      generic: 'Не удалось выполнить запрос. Попробуйте позже.',
      routeNotFound: 'Сервис недоступен. Проверьте, что сервер запущен и маршруты API настроены.',
      server_error: 'Ошибка сервера. Попробуйте позже.',
      unauthorized: 'Нужно войти в аккаунт',
      auth_failed: 'Неверный email или пароль',
      validation_error: 'Проверьте введённые данные',
      ValidationError: 'Проверьте введённые данные',
      user_exists: 'Этот email уже зарегистрирован',
      auth_wrong_password: 'Неверный текущий пароль',
      auth_same_password: 'Новый пароль должен отличаться от текущего',
    },
    roleMismatchTitle: 'Неверное приложение',
    roleMismatchMessage:
      'Эта сборка для роли «{expected}». Вы вошли как «{actual}». Откройте нужное приложение или выйдите из аккаунта.',
    roleMismatchLogout: 'Выйти',
  },
}
